import { create } from "zustand"

/* -------------------------------------------------------------------------------------------------
 * types
 * -----------------------------------------------------------------------------------------------*/
type RequestIdStoreData = Record<string, string>

type RequestIdStore = {
  data: RequestIdStoreData
  setData: (data: Record<string, string>) => void
}

/* -------------------------------------------------------------------------------------------------
 * config
 * -----------------------------------------------------------------------------------------------*/

const initialState: RequestIdStoreData = {}

/* -------------------------------------------------------------------------------------------------
 * store
 * -----------------------------------------------------------------------------------------------*/
const useRequestIdStore = create<RequestIdStore>((set) => ({
  data: initialState,
  setData: (data) => {
    set((state) => {
      state.data = { ...state.data, ...data }
      return state
    })
  },
}))

export default useRequestIdStore
